import React from 'react';
import { Upload, Plug, Rocket } from 'lucide-react';

const steps = [
  {
    n: '01',
    icon: <Upload size={22} />,
    title: 'Upload your knowledge',
    desc: 'Drag in PDFs, spreadsheets or pick from Google Drive. AINA learns your products, policies and tone in minutes.',
  },
  {
    n: '02',
    icon: <Plug size={22} />,
    title: 'Connect your channels',
    desc: 'Plug in WhatsApp, Instagram, Telegram, Facebook and your website widget — all from one settings panel.',
  },
  {
    n: '03',
    icon: <Rocket size={22} />,
    title: 'Launch & convert',
    desc: 'Your AI starts qualifying leads, booking appointments and answering 24/7 — every chat tracked in your CRM.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="how">
      <div className="container">
        <div className="how__head reveal">
          <span className="eyebrow">How it works</span>
          <h2 className="how__title">From zero to AI agent in under 10 minutes</h2>
          <p className="how__desc">
            No code. No agency. No 6-week implementation. Just upload, connect, launch.
          </p>
        </div>

        <div className="how__grid">
          {steps.map((s, i) => (
            <div key={s.n} className="howCard reveal" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="howCard__top">
                <span className="howCard__num">{s.n}</span>
                <span className="howCard__icon">{s.icon}</span>
              </div>
              <h3 className="howCard__title">{s.title}</h3>
              <p className="howCard__desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
